import { FavouriteItem, FavouriteItemDraft, FavouriteItemType } from "../types";

export function favouriteItemToDraft(item: FavouriteItem): FavouriteItemDraft {
  switch (item.type) {
    case FavouriteItemType.Map:
      return {
        type: FavouriteItemType.Map,
        name: item.name,
        mark: {
          parameters: item.mark.parameters,
        },
      };
    case FavouriteItemType.Slide:
      return {
        type: FavouriteItemType.Slide,
        name: item.name,
        mark: {
          reportId: item.mark.reportId,
          parameters: item.mark.parameters,
        },
      };
    case FavouriteItemType.BulkExport:
      return {
        type: FavouriteItemType.BulkExport,
        name: item.name,
        date: item.date,
        mark: {
          parameters: item.mark.parameters,
        },
      };
    case FavouriteItemType.SavedBulkExport:
      return {
        type: FavouriteItemType.SavedBulkExport,
        name: item.name,
        date: item.date,
        mark: {
          savedBulkExportSettingsId: item.mark.savedBulkExportSettingsId as number,
        },
      };
    default:
      return item;
  }
}
